import { TestRunsDto } from '../dto/hardware-tests.dto'
import { TestRunsModel, TriggerHardwareTestParamsData } from '../models'

/**
 * currently SW1 returns a string of a JSON object but will update it to a JSON object in the future. This way we try to prevent the app from breaking when the change happens.
 * TODO: update, when SW1 has fixed their params type
 */
const transformParameters = (params?: string | TriggerHardwareTestParamsData): TriggerHardwareTestParamsData | undefined => {
  if (!params) return undefined

  if (typeof params === 'string') {
    return JSON.parse(params)
  }

  if (typeof params === 'object') {
    return params
  }
}

const fromDtoToTestRunRecordModelTransformer = (dto: TestRunsDto): TestRunsModel => ({
  totalCount: dto.totalCount,
  data: dto.items.map(elem => ({
    message: elem.message || {
      key: '',
      alternativeText: '',
    },
    startedAt: elem.startedAt || '',
    state: elem.state || 'FAILURE',
    testId: elem.testId || '',
    testRunId: elem.testRunId || '',
    userId: elem.userId || 0,
    userName: elem.userName || '',
    params: transformParameters(elem.params),
  })),
})

export default fromDtoToTestRunRecordModelTransformer
